import {useMemo} from '@wordpress/element';

export const useElementOptions = (
    {
        cartTotal,
        currency,
        elementOptions,
        expressCheckout = false,
        shouldSavePayment = false,
    }) => {
    return useMemo(() => {
        let options = {
            mode: 'payment',
            currency: currency?.code?.toLowerCase(),
            ...elementOptions
        };
        if (shouldSavePayment && options.mode !== 'subscription') {
            options.mode = 'setup';
        }
        if (cartTotal.value <= 0 && options.mode !== 'subscription') {
            options = {...options, mode: 'setup'};
        }
        if (['payment', 'subscription'].includes(options.mode)) {
            options.amount = cartTotal.value;
        }
        if (expressCheckout) {
            delete options.paymentMethodTypes;
        }
        return options;
    }, [
        cartTotal.value,
        currency?.code,
        expressCheckout,
        shouldSavePayment
    ]);
};
